var countries_cart = {
    "countries":[
       {
          "id":87771643940,
          "name":"Austria",
          "code":"AT",
          "zip_capital":"1010",
          "tax_name":"AT VAT",
          "tax":0.2,
          "provinces":[
             
          ],
       },
       {
          "id":87771709476,
          "name":"Belgium",
          "code":"BE",
          "zip_capital":"1000",
          "tax_name":"BE TVA",
          "tax":0.21,
          "provinces":[
             
          ]
       },
       {
          "id":87771807780,
          "name":"Bulgaria",
          "code":"BG",
          "zip_capital":"1000",
          "tax_name":"BG VAT",
          "tax":0.2,
          "provinces":[
             
          ]
       },
       {
          "id":87771840548,
          "name":"Croatia",
          "code":"HR",
          "zip_capital":"21000",
          "tax_name":"HR VAT",
          "tax":0.25,
          "provinces":[
             
          ]
       },
       {
          "id":87771873316,
          "name":"Cyprus",
          "code":"CY",
          "zip_capital":"1010",
          "tax_name":"CY VAT",
          "tax":0.19,
          "provinces":[
             
          ]
       },
       {
          "id":87771906084,
          "name":"Czech Republic",
          "code":"CZ",
          "zip_capital":"10000",
          "tax_name":"CZ VAT",
          "tax":0.21,
          "provinces":[
             
          ]
       },
       {
          "id":87771938852,
          "name":"Denmark",
          "code":"DK",
          "zip_capital":"1000",
          "tax_name":"DK Moms",
          "tax":0.25,
          "provinces":[
             
          ]
       },
       {
          "id":87771971620,
          "name":"Estonia",
          "code":"EE",
          "zip_capital":"67102",
          "tax_name":"EE VAT",
          "tax":0.2,
          "provinces":[
             
          ]
       },
       {
          "id":87772037156,
          "name":"Finland",
          "code":"FI",
          "zip_capital":"00531",
          "tax_name":"FI ALV",
          "tax":0.24,
          "provinces":[
             
          ]
       },
       {
          "id":82239488036,
          "name":"France",
          "code":"FR",
          "zip_capital":"75000",
          "tax_name":"FR TVA",
          "tax":0.2,
          "provinces":[
             
          ]
       },
       {
          "id":87772102692,
          "name":"Germany",
          "code":"DE",
          "zip_capital":"10115",
          "tax_name":"DE MwSt",
          "tax":0.19,
          "provinces":[
             
          ]
       },
       {
          "id":87772168228,
          "name":"Greece",
          "code":"GR",
          "zip_capital":"10431",
          "tax_name":"GR VAT",
          "tax":0.24,
          "provinces":[
             
          ]
       },
       {
          "id":87772233764,
          "name":"Guadeloupe",
          "code":"GP",
          "zip_capital":"97180",
          "tax_name":"TVA",
          "tax":0,
          "provinces":[
             
          ]
       },
       {
          "id":87772332068,
          "name":"Hungary",
          "code":"HU",
          "zip_capital":"1011",
          "tax_name":"HU VAT",
          "tax":0.27,
          "provinces":[
             
          ]
       },
       {
          "id":87772397604,
          "name":"Ireland",
          "code":"IE",
          "zip_capital":"R93 A003",
          "tax_name":"IE VAT",
          "tax":0.23,
          "provinces":[
             {
                "id":904479146020,
                "country_id":87772397604,
                "name":"Carlow",
                "code":"CW",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479178788,
                "country_id":87772397604,
                "name":"Cavan",
                "code":"CN",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479211556,
                "country_id":87772397604,
                "name":"Clare",
                "code":"CE",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479244324,
                "country_id":87772397604,
                "name":"Cork",
                "code":"CO",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479277092,
                "country_id":87772397604,
                "name":"Donegal",
                "code":"DL",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479309860,
                "country_id":87772397604,
                "name":"Dublin",
                "code":"D",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479342628,
                "country_id":87772397604,
                "name":"Galway",
                "code":"G",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479375396,
                "country_id":87772397604,
                "name":"Kerry",
                "code":"KY",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479408164,
                "country_id":87772397604,
                "name":"Kildare",
                "code":"KE",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479440932,
                "country_id":87772397604,
                "name":"Kilkenny",
                "code":"KK",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479473700,
                "country_id":87772397604,
                "name":"Laois",
                "code":"LS",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479506468,
                "country_id":87772397604,
                "name":"Leitrim",
                "code":"LM",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479539236,
                "country_id":87772397604,
                "name":"Limerick",
                "code":"LK",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479572004,
                "country_id":87772397604,
                "name":"Longford",
                "code":"LD",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479604772,
                "country_id":87772397604,
                "name":"Louth",
                "code":"LH",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479637540,
                "country_id":87772397604,
                "name":"Mayo",
                "code":"MO",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479670308,
                "country_id":87772397604,
                "name":"Meath",
                "code":"MH",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479703076,
                "country_id":87772397604,
                "name":"Monaghan",
                "code":"MN",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479735844,
                "country_id":87772397604,
                "name":"Offaly",
                "code":"OY",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479768612,
                "country_id":87772397604,
                "name":"Roscommon",
                "code":"RN",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479801380,
                "country_id":87772397604,
                "name":"Sligo",
                "code":"SO",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479834148,
                "country_id":87772397604,
                "name":"Tipperary",
                "code":"TA",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479866916,
                "country_id":87772397604,
                "name":"Waterford",
                "code":"WD",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479899684,
                "country_id":87772397604,
                "name":"Westmeath",
                "code":"WH",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479932452,
                "country_id":87772397604,
                "name":"Wexford",
                "code":"WX",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904479965220,
                "country_id":87772397604,
                "name":"Wicklow",
                "code":"WW",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             }
          ]
       },
       {
          "id":87772463140,
          "name":"Italy",
          "code":"IT",
          "zip_capital":"92100",
          "tax_name":"IT IVA",
          "tax":0.22,
          "provinces":[
             {
                "id":904479997988,
                "country_id":87772463140,
                "name":"Agrigento",
                "code":"AG",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480030756,
                "country_id":87772463140,
                "name":"Alessandria",
                "code":"AL",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480063524,
                "country_id":87772463140,
                "name":"Ancona",
                "code":"AN",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480096292,
                "country_id":87772463140,
                "name":"Aosta",
                "code":"AO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480129060,
                "country_id":87772463140,
                "name":"Arezzo",
                "code":"AR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480161828,
                "country_id":87772463140,
                "name":"Ascoli Piceno",
                "code":"AP",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480194596,
                "country_id":87772463140,
                "name":"Asti",
                "code":"AT",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480227364,
                "country_id":87772463140,
                "name":"Avellino",
                "code":"AV",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480260132,
                "country_id":87772463140,
                "name":"Bari",
                "code":"BA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480292900,
                "country_id":87772463140,
                "name":"Barletta-Andria-Trani",
                "code":"BT",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480325668,
                "country_id":87772463140,
                "name":"Belluno",
                "code":"BL",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480358436,
                "country_id":87772463140,
                "name":"Benevento",
                "code":"BN",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480391204,
                "country_id":87772463140,
                "name":"Bergamo",
                "code":"BG",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480423972,
                "country_id":87772463140,
                "name":"Biella",
                "code":"BI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480456740,
                "country_id":87772463140,
                "name":"Bologna",
                "code":"BO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480489508,
                "country_id":87772463140,
                "name":"Bolzano",
                "code":"BZ",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480522276,
                "country_id":87772463140,
                "name":"Brescia",
                "code":"BS",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480555044,
                "country_id":87772463140,
                "name":"Brindisi",
                "code":"BR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480587812,
                "country_id":87772463140,
                "name":"Cagliari",
                "code":"CA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480620580,
                "country_id":87772463140,
                "name":"Caltanissetta",
                "code":"CL",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480653348,
                "country_id":87772463140,
                "name":"Campobasso",
                "code":"CB",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480686116,
                "country_id":87772463140,
                "name":"Carbonia-Iglesias",
                "code":"CI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480718884,
                "country_id":87772463140,
                "name":"Caserta",
                "code":"CE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480751652,
                "country_id":87772463140,
                "name":"Catania",
                "code":"CT",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480784420,
                "country_id":87772463140,
                "name":"Catanzaro",
                "code":"CZ",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480817188,
                "country_id":87772463140,
                "name":"Chieti",
                "code":"CH",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480849956,
                "country_id":87772463140,
                "name":"Como",
                "code":"CO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480882724,
                "country_id":87772463140,
                "name":"Cosenza",
                "code":"CS",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480915492,
                "country_id":87772463140,
                "name":"Cremona",
                "code":"CR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480948260,
                "country_id":87772463140,
                "name":"Crotone",
                "code":"KR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904480981028,
                "country_id":87772463140,
                "name":"Cuneo",
                "code":"CN",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481013796,
                "country_id":87772463140,
                "name":"Enna",
                "code":"EN",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481046564,
                "country_id":87772463140,
                "name":"Fermo",
                "code":"FM",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481079332,
                "country_id":87772463140,
                "name":"Ferrara",
                "code":"FE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481112100,
                "country_id":87772463140,
                "name":"Firenze",
                "code":"FI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481144868,
                "country_id":87772463140,
                "name":"Foggia",
                "code":"FG",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481177636,
                "country_id":87772463140,
                "name":"Forlì-Cesena",
                "code":"FC",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481210404,
                "country_id":87772463140,
                "name":"Frosinone",
                "code":"FR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481243172,
                "country_id":87772463140,
                "name":"Genova",
                "code":"GE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481275940,
                "country_id":87772463140,
                "name":"Gorizia",
                "code":"GO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481308708,
                "country_id":87772463140,
                "name":"Grosseto",
                "code":"GR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481341476,
                "country_id":87772463140,
                "name":"Imperia",
                "code":"IM",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481374244,
                "country_id":87772463140,
                "name":"Isernia",
                "code":"IS",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481407012,
                "country_id":87772463140,
                "name":"L'Aquila",
                "code":"AQ",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481439780,
                "country_id":87772463140,
                "name":"La Spezia",
                "code":"SP",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481472548,
                "country_id":87772463140,
                "name":"Latina",
                "code":"LT",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481505316,
                "country_id":87772463140,
                "name":"Lecce",
                "code":"LE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481538084,
                "country_id":87772463140,
                "name":"Lecco",
                "code":"LC",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481570852,
                "country_id":87772463140,
                "name":"Livorno",
                "code":"LI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481603620,
                "country_id":87772463140,
                "name":"Lodi",
                "code":"LO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481636388,
                "country_id":87772463140,
                "name":"Lucca",
                "code":"LU",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481669156,
                "country_id":87772463140,
                "name":"Macerata",
                "code":"MC",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481701924,
                "country_id":87772463140,
                "name":"Mantova",
                "code":"MN",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481734692,
                "country_id":87772463140,
                "name":"Massa-Carrara",
                "code":"MS",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481767460,
                "country_id":87772463140,
                "name":"Matera",
                "code":"MT",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481800228,
                "country_id":87772463140,
                "name":"Medio Campidano",
                "code":"VS",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481832996,
                "country_id":87772463140,
                "name":"Messina",
                "code":"ME",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481865764,
                "country_id":87772463140,
                "name":"Milano",
                "code":"MI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481898532,
                "country_id":87772463140,
                "name":"Modena",
                "code":"MO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481931300,
                "country_id":87772463140,
                "name":"Monza e Brianza",
                "code":"MB",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481964068,
                "country_id":87772463140,
                "name":"Napoli",
                "code":"NA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904481996836,
                "country_id":87772463140,
                "name":"Novara",
                "code":"NO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482029604,
                "country_id":87772463140,
                "name":"Nuoro",
                "code":"NU",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482062372,
                "country_id":87772463140,
                "name":"Ogliastra",
                "code":"OG",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482095140,
                "country_id":87772463140,
                "name":"Olbia-Tempio",
                "code":"OT",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482127908,
                "country_id":87772463140,
                "name":"Oristano",
                "code":"OR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482160676,
                "country_id":87772463140,
                "name":"Padova",
                "code":"PD",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482193444,
                "country_id":87772463140,
                "name":"Palermo",
                "code":"PA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482226212,
                "country_id":87772463140,
                "name":"Parma",
                "code":"PR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482258980,
                "country_id":87772463140,
                "name":"Pavia",
                "code":"PV",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482291748,
                "country_id":87772463140,
                "name":"Perugia",
                "code":"PG",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482324516,
                "country_id":87772463140,
                "name":"Pesaro e Urbino",
                "code":"PU",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482357284,
                "country_id":87772463140,
                "name":"Pescara",
                "code":"PE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482390052,
                "country_id":87772463140,
                "name":"Piacenza",
                "code":"PC",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482422820,
                "country_id":87772463140,
                "name":"Pisa",
                "code":"PI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482455588,
                "country_id":87772463140,
                "name":"Pistoia",
                "code":"PT",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482488356,
                "country_id":87772463140,
                "name":"Pordenone",
                "code":"PN",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482521124,
                "country_id":87772463140,
                "name":"Potenza",
                "code":"PZ",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482553892,
                "country_id":87772463140,
                "name":"Prato",
                "code":"PO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482586660,
                "country_id":87772463140,
                "name":"Ragusa",
                "code":"RG",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482619428,
                "country_id":87772463140,
                "name":"Ravenna",
                "code":"RA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482652196,
                "country_id":87772463140,
                "name":"Reggio Calabria",
                "code":"RC",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482684964,
                "country_id":87772463140,
                "name":"Reggio Emilia",
                "code":"RE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482717732,
                "country_id":87772463140,
                "name":"Rieti",
                "code":"RI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482750500,
                "country_id":87772463140,
                "name":"Rimini",
                "code":"RN",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482783268,
                "country_id":87772463140,
                "name":"Roma",
                "code":"RM",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482816036,
                "country_id":87772463140,
                "name":"Rovigo",
                "code":"RO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482848804,
                "country_id":87772463140,
                "name":"Salerno",
                "code":"SA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482881572,
                "country_id":87772463140,
                "name":"Sassari",
                "code":"SS",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482914340,
                "country_id":87772463140,
                "name":"Savona",
                "code":"SV",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482947108,
                "country_id":87772463140,
                "name":"Siena",
                "code":"SI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904482979876,
                "country_id":87772463140,
                "name":"Siracusa",
                "code":"SR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483012644,
                "country_id":87772463140,
                "name":"Sondrio",
                "code":"SO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483045412,
                "country_id":87772463140,
                "name":"Taranto",
                "code":"TA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483078180,
                "country_id":87772463140,
                "name":"Teramo",
                "code":"TE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483110948,
                "country_id":87772463140,
                "name":"Terni",
                "code":"TR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483143716,
                "country_id":87772463140,
                "name":"Torino",
                "code":"TO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483176484,
                "country_id":87772463140,
                "name":"Trapani",
                "code":"TP",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483209252,
                "country_id":87772463140,
                "name":"Trento",
                "code":"TN",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483242020,
                "country_id":87772463140,
                "name":"Treviso",
                "code":"TV",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483274788,
                "country_id":87772463140,
                "name":"Trieste",
                "code":"TS",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483307556,
                "country_id":87772463140,
                "name":"Udine",
                "code":"UD",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483340324,
                "country_id":87772463140,
                "name":"Varese",
                "code":"VA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483373092,
                "country_id":87772463140,
                "name":"Venezia",
                "code":"VE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483405860,
                "country_id":87772463140,
                "name":"Verbano-Cusio-Ossola",
                "code":"VB",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483438628,
                "country_id":87772463140,
                "name":"Vercelli",
                "code":"VC",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483471396,
                "country_id":87772463140,
                "name":"Verona",
                "code":"VR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483504164,
                "country_id":87772463140,
                "name":"Vibo Valentia",
                "code":"VV",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483536932,
                "country_id":87772463140,
                "name":"Vicenza",
                "code":"VI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483569700,
                "country_id":87772463140,
                "name":"Viterbo",
                "code":"VT",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             }
          ]
       },
       {
          "id":87772626980,
          "name":"Lithuania",
          "code":"LT",
          "tax_name":"LT VAT",
          "zip_capital":"01124",
          "tax":0.21,
          "provinces":[
             
          ]
       },
       {
          "id":87772659748,
          "name":"Luxembourg",
          "code":"LU",
          "zip_capital":"1111",
          "tax_name":"LU VAT",
          "tax":0.17,
          "provinces":[
             
          ]
       },
       {
          "id":87772725284,
          "name":"Malta",
          "code":"MT",
          "zip_capital":"VLT",
          "tax_name":"MT VAT",
          "tax":0.18,
          "provinces":[
             
          ]
       },
       {
          "id":87772758052,
          "name":"Mayotte",
          "code":"YT",
          "zip_capital":"97660",
          "tax_name":"VAT",
          "tax":0,
          "provinces":[
             
          ]
       },
       {
          "id":87772823588,
          "name":"Monaco",
          "code":"MC",
          "zip_capital":"98000",
          "tax_name":"VAT",
          "tax":0,
          "provinces":[
             
          ]
       },
       {
          "id":87772889124,
          "name":"Netherlands",
          "code":"NL",
          "zip_capital":"1011",
          "tax_name":"NL btw",
          "tax":0.21,
          "provinces":[
             
          ]
       },
       {
          "id":87772954660,
          "name":"Poland",
          "code":"PL",
          "zip_capital":"00-001",
          "tax_name":"PL VAT",
          "tax":0.23,
          "provinces":[
             
          ]
       },
       {
          "id":87772987428,
          "name":"Portugal",
          "code":"PT",
          "zip_capital":"4301",
          "tax_name":"PT VAT",
          "tax":0.23,
          "provinces":[
             {
                "id":904483602468,
                "country_id":87772987428,
                "name":"Açores",
                "code":"PT-20",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483635236,
                "country_id":87772987428,
                "name":"Aveiro",
                "code":"PT-01",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483668004,
                "country_id":87772987428,
                "name":"Beja",
                "code":"PT-02",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483700772,
                "country_id":87772987428,
                "name":"Braga",
                "code":"PT-03",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483733540,
                "country_id":87772987428,
                "name":"Bragança",
                "code":"PT-04",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483766308,
                "country_id":87772987428,
                "name":"Castelo Branco",
                "code":"PT-05",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483799076,
                "country_id":87772987428,
                "name":"Coimbra",
                "code":"PT-06",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483831844,
                "country_id":87772987428,
                "name":"Évora",
                "code":"PT-07",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483864612,
                "country_id":87772987428,
                "name":"Faro",
                "code":"PT-08",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483897380,
                "country_id":87772987428,
                "name":"Guarda",
                "code":"PT-09",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483930148,
                "country_id":87772987428,
                "name":"Leiria",
                "code":"PT-10",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483962916,
                "country_id":87772987428,
                "name":"Lisboa",
                "code":"PT-11",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904483995684,
                "country_id":87772987428,
                "name":"Madeira",
                "code":"PT-30",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484028452,
                "country_id":87772987428,
                "name":"Portalegre",
                "code":"PT-12",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484061220,
                "country_id":87772987428,
                "name":"Porto",
                "code":"PT-13",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484093988,
                "country_id":87772987428,
                "name":"Santarém",
                "code":"PT-14",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484126756,
                "country_id":87772987428,
                "name":"Setúbal",
                "code":"PT-15",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484159524,
                "country_id":87772987428,
                "name":"Viana do Castelo",
                "code":"PT-16",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484192292,
                "country_id":87772987428,
                "name":"Vila Real",
                "code":"PT-17",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484225060,
                "country_id":87772987428,
                "name":"Viseu",
                "code":"PT-18",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             }
          ]
       },
       {
          "id":87773020196,
          "name":"Reunion",
          "code":"RE",
          "zip_capital":"97400",
          "tax_name":"Tax",
          "tax":0,
          "provinces":[
             
          ]
       },
       {
          "id":87773052964,
          "name":"Romania",
          "code":"RO",
          "zip_capital":"510002",
          "tax_name":"RO VAT",
          "tax":0.19,
          "provinces":[
             {
                "id":904484257828,
                "country_id":87773052964,
                "name":"Alba",
                "code":"AB",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484290596,
                "country_id":87773052964,
                "name":"Arad",
                "code":"AR",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484323364,
                "country_id":87773052964,
                "name":"Argeș",
                "code":"AG",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484356132,
                "country_id":87773052964,
                "name":"Bacău",
                "code":"BC",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484388900,
                "country_id":87773052964,
                "name":"Bihor",
                "code":"BH",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484421668,
                "country_id":87773052964,
                "name":"Bistrița-Năsăud",
                "code":"BN",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484454436,
                "country_id":87773052964,
                "name":"Botoșani",
                "code":"BT",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484519972,
                "country_id":87773052964,
                "name":"Brăila",
                "code":"BR",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484487204,
                "country_id":87773052964,
                "name":"Brașov",
                "code":"BV",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484552740,
                "country_id":87773052964,
                "name":"București",
                "code":"B",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484585508,
                "country_id":87773052964,
                "name":"Buzău",
                "code":"BZ",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484618276,
                "country_id":87773052964,
                "name":"Călărași",
                "code":"CL",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484651044,
                "country_id":87773052964,
                "name":"Caraș-Severin",
                "code":"CS",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484683812,
                "country_id":87773052964,
                "name":"Cluj",
                "code":"CJ",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484716580,
                "country_id":87773052964,
                "name":"Constanța",
                "code":"CT",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484749348,
                "country_id":87773052964,
                "name":"Covasna",
                "code":"CV",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484782116,
                "country_id":87773052964,
                "name":"Dâmbovița",
                "code":"DB",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484814884,
                "country_id":87773052964,
                "name":"Dolj",
                "code":"DJ",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484847652,
                "country_id":87773052964,
                "name":"Galați",
                "code":"GL",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484880420,
                "country_id":87773052964,
                "name":"Giurgiu",
                "code":"GR",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484913188,
                "country_id":87773052964,
                "name":"Gorj",
                "code":"GJ",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484945956,
                "country_id":87773052964,
                "name":"Harghita",
                "code":"HR",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904484978724,
                "country_id":87773052964,
                "name":"Hunedoara",
                "code":"HD",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485044260,
                "country_id":87773052964,
                "name":"Ialomița",
                "code":"IL",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485011492,
                "country_id":87773052964,
                "name":"Iași",
                "code":"IS",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485077028,
                "country_id":87773052964,
                "name":"Ilfov",
                "code":"IF",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485109796,
                "country_id":87773052964,
                "name":"Maramureș",
                "code":"MM",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485142564,
                "country_id":87773052964,
                "name":"Mehedinți",
                "code":"MH",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485175332,
                "country_id":87773052964,
                "name":"Mureș",
                "code":"MS",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485208100,
                "country_id":87773052964,
                "name":"Neamț",
                "code":"NT",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485240868,
                "country_id":87773052964,
                "name":"Olt",
                "code":"OT",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485273636,
                "country_id":87773052964,
                "name":"Prahova",
                "code":"PH",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485306404,
                "country_id":87773052964,
                "name":"Sălaj",
                "code":"SJ",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485339172,
                "country_id":87773052964,
                "name":"Satu Mare",
                "code":"SM",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485371940,
                "country_id":87773052964,
                "name":"Sibiu",
                "code":"SB",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485404708,
                "country_id":87773052964,
                "name":"Suceava",
                "code":"SV",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485437476,
                "country_id":87773052964,
                "name":"Teleorman",
                "code":"TR",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485470244,
                "country_id":87773052964,
                "name":"Timiș",
                "code":"TM",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485503012,
                "country_id":87773052964,
                "name":"Tulcea",
                "code":"TL",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485535780,
                "country_id":87773052964,
                "name":"Vâlcea",
                "code":"VL",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485568548,
                "country_id":87773052964,
                "name":"Vaslui",
                "code":"VS",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485601316,
                "country_id":87773052964,
                "name":"Vrancea",
                "code":"VN",
                "tax_name":"Tax",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             }
          ]
       },
       {
          "id":87773151268,
          "name":"Slovakia",
          "code":"SK",
          "zip_capital":"811 01",
          "tax_name":"SK VAT",
          "tax":0.2,
          "provinces":[
             
          ]
       },
       {
          "id":87773184036,
          "name":"Slovenia",
          "code":"SI",
          "zip_capital":"6280",
          "tax_name":"SI VAT",
          "tax":0.22,
          "provinces":[
             
          ]
       },
       {
          "id":87773216804,
          "name":"Spain",
          "code":"ES",
          "zip_capital":"15365",
          "tax_name":"ES IVA",
          "tax":0.21,
          "provinces":[
             {
                "id":904485634084,
                "country_id":87773216804,
                "name":"A Coruña",
                "code":"C",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485666852,
                "country_id":87773216804,
                "name":"Álava",
                "code":"VI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485699620,
                "country_id":87773216804,
                "name":"Albacete",
                "code":"AB",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485732388,
                "country_id":87773216804,
                "name":"Alicante",
                "code":"A",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485765156,
                "country_id":87773216804,
                "name":"Almería",
                "code":"AL",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485797924,
                "country_id":87773216804,
                "name":"Asturias",
                "code":"O",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485830692,
                "country_id":87773216804,
                "name":"Ávila",
                "code":"AV",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485863460,
                "country_id":87773216804,
                "name":"Badajoz",
                "code":"BA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485896228,
                "country_id":87773216804,
                "name":"Balears",
                "code":"PM",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485928996,
                "country_id":87773216804,
                "name":"Barcelona",
                "code":"B",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485961764,
                "country_id":87773216804,
                "name":"Burgos",
                "code":"BU",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904485994532,
                "country_id":87773216804,
                "name":"Cáceres",
                "code":"CC",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486027300,
                "country_id":87773216804,
                "name":"Cádiz",
                "code":"CA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486060068,
                "country_id":87773216804,
                "name":"Cantabria",
                "code":"S",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486092836,
                "country_id":87773216804,
                "name":"Castellón",
                "code":"CS",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486125604,
                "country_id":87773216804,
                "name":"Ceuta",
                "code":"CE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486158372,
                "country_id":87773216804,
                "name":"Ciudad Real",
                "code":"CR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486191140,
                "country_id":87773216804,
                "name":"Córdoba",
                "code":"CO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486223908,
                "country_id":87773216804,
                "name":"Cuenca",
                "code":"CU",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486256676,
                "country_id":87773216804,
                "name":"Girona",
                "code":"GI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486289444,
                "country_id":87773216804,
                "name":"Granada",
                "code":"GR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486322212,
                "country_id":87773216804,
                "name":"Guadalajara",
                "code":"GU",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486354980,
                "country_id":87773216804,
                "name":"Guipúzcoa",
                "code":"SS",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486387748,
                "country_id":87773216804,
                "name":"Huelva",
                "code":"H",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486420516,
                "country_id":87773216804,
                "name":"Huesca",
                "code":"HU",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486453284,
                "country_id":87773216804,
                "name":"Jaén",
                "code":"J",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486486052,
                "country_id":87773216804,
                "name":"La Rioja",
                "code":"LO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486518820,
                "country_id":87773216804,
                "name":"Las Palmas",
                "code":"GC",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486551588,
                "country_id":87773216804,
                "name":"León",
                "code":"LE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486584356,
                "country_id":87773216804,
                "name":"Lleida",
                "code":"L",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486617124,
                "country_id":87773216804,
                "name":"Lugo",
                "code":"LU",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486649892,
                "country_id":87773216804,
                "name":"Madrid",
                "code":"M",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486682660,
                "country_id":87773216804,
                "name":"Málaga",
                "code":"MA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486715428,
                "country_id":87773216804,
                "name":"Melilla",
                "code":"ML",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486748196,
                "country_id":87773216804,
                "name":"Murcia",
                "code":"MU",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486780964,
                "country_id":87773216804,
                "name":"Navarra",
                "code":"NA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486813732,
                "country_id":87773216804,
                "name":"Ourense",
                "code":"OR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486846500,
                "country_id":87773216804,
                "name":"Palencia",
                "code":"P",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486879268,
                "country_id":87773216804,
                "name":"Pontevedra",
                "code":"PO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486912036,
                "country_id":87773216804,
                "name":"Salamanca",
                "code":"SA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486944804,
                "country_id":87773216804,
                "name":"Santa Cruz de Tenerife",
                "code":"TF",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904486977572,
                "country_id":87773216804,
                "name":"Segovia",
                "code":"SG",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904487010340,
                "country_id":87773216804,
                "name":"Sevilla",
                "code":"SE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904487043108,
                "country_id":87773216804,
                "name":"Soria",
                "code":"SO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904487075876,
                "country_id":87773216804,
                "name":"Tarragona",
                "code":"T",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904487108644,
                "country_id":87773216804,
                "name":"Teruel",
                "code":"TE",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904487141412,
                "country_id":87773216804,
                "name":"Toledo",
                "code":"TO",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904487174180,
                "country_id":87773216804,
                "name":"Valencia",
                "code":"V",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904487206948,
                "country_id":87773216804,
                "name":"Valladolid",
                "code":"VA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904487239716,
                "country_id":87773216804,
                "name":"Vizcaya",
                "code":"BI",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904487272484,
                "country_id":87773216804,
                "name":"Zamora",
                "code":"ZA",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904487305252,
                "country_id":87773216804,
                "name":"Zaragoza",
                "code":"Z",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":46431272996,
                "tax":0,
                "tax_percentage":0
             }
          ]
       },
       {
          "id":87773282340,
          "name":"Sweden",
          "code":"SE",
          "zip_capital":"100 05",
          "tax_name":"SE Moms",
          "tax":0.25,
          "provinces":[
             
          ]
       },
       {
          "id":87773315108,
          "name":"Switzerland",
          "code":"CH",
          "zip_capital":"3000",
          "tax_name":"MwSt",
          "tax":0,
          "provinces":[
             
          ]
       },
       {
          "id":87773413412,
          "name":"United Kingdom",
          "code":"GB",
          "zip_capital":"WC2N 5DU",
          "tax_name":"GB VAT",
          "tax":0.2,
          "provinces":[
             {
                "id":4099441229860,
                "country_id":87773413412,
                "name":"England",
                "code":"ENG",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":null,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":4099441262628,
                "country_id":87773413412,
                "name":"Northern Ireland",
                "code":"NIR",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":null,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":4099441295396,
                "country_id":87773413412,
                "name":"Scotland",
                "code":"SCT",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":null,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":4099441328164,
                "country_id":87773413412,
                "name":"Wales",
                "code":"WLS",
                "tax_name":"VAT",
                "tax_type":null,
                "shipping_zone_id":null,
                "tax":0,
                "tax_percentage":0
             }
          ]
       },
       {
          "id":87775772708,
          "name":"United States",
          "code":"US",
          "zip_capital":"35242",
          "tax_name":"Federal Tax",
          "tax":0,
          "provinces":[
             {
                "id":904523284516,
                "country_id":87775772708,
                "name":"Alabama",
                "code":"AL",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523317284,
                "country_id":87775772708,
                "name":"Alaska",
                "code":"AK",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523350052,
                "country_id":87775772708,
                "name":"American Samoa",
                "code":"AS",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523382820,
                "country_id":87775772708,
                "name":"Arizona",
                "code":"AZ",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523415588,
                "country_id":87775772708,
                "name":"Arkansas",
                "code":"AR",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904525217828,
                "country_id":87775772708,
                "name":"Armed Forces Americas",
                "code":"AA",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904525250596,
                "country_id":87775772708,
                "name":"Armed Forces Europe",
                "code":"AE",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904525283364,
                "country_id":87775772708,
                "name":"Armed Forces Pacific",
                "code":"AP",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523448356,
                "country_id":87775772708,
                "name":"California",
                "code":"CA",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523481124,
                "country_id":87775772708,
                "name":"Colorado",
                "code":"CO",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523513892,
                "country_id":87775772708,
                "name":"Connecticut",
                "code":"CT",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523546660,
                "country_id":87775772708,
                "name":"Delaware",
                "code":"DE",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523579428,
                "country_id":87775772708,
                "name":"District of Columbia",
                "code":"DC",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523612196,
                "country_id":87775772708,
                "name":"Federated States of Micronesia",
                "code":"FM",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523644964,
                "country_id":87775772708,
                "name":"Florida",
                "code":"FL",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523677732,
                "country_id":87775772708,
                "name":"Georgia",
                "code":"GA",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523710500,
                "country_id":87775772708,
                "name":"Guam",
                "code":"GU",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523743268,
                "country_id":87775772708,
                "name":"Hawaii",
                "code":"HI",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523776036,
                "country_id":87775772708,
                "name":"Idaho",
                "code":"ID",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523808804,
                "country_id":87775772708,
                "name":"Illinois",
                "code":"IL",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523841572,
                "country_id":87775772708,
                "name":"Indiana",
                "code":"IN",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523874340,
                "country_id":87775772708,
                "name":"Iowa",
                "code":"IA",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523907108,
                "country_id":87775772708,
                "name":"Kansas",
                "code":"KS",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523939876,
                "country_id":87775772708,
                "name":"Kentucky",
                "code":"KY",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904523972644,
                "country_id":87775772708,
                "name":"Louisiana",
                "code":"LA",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524005412,
                "country_id":87775772708,
                "name":"Maine",
                "code":"ME",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524038180,
                "country_id":87775772708,
                "name":"Marshall Islands",
                "code":"MH",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524070948,
                "country_id":87775772708,
                "name":"Maryland",
                "code":"MD",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524103716,
                "country_id":87775772708,
                "name":"Massachusetts",
                "code":"MA",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524136484,
                "country_id":87775772708,
                "name":"Michigan",
                "code":"MI",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524169252,
                "country_id":87775772708,
                "name":"Minnesota",
                "code":"MN",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524202020,
                "country_id":87775772708,
                "name":"Mississippi",
                "code":"MS",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524234788,
                "country_id":87775772708,
                "name":"Missouri",
                "code":"MO",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524267556,
                "country_id":87775772708,
                "name":"Montana",
                "code":"MT",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524300324,
                "country_id":87775772708,
                "name":"Nebraska",
                "code":"NE",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524333092,
                "country_id":87775772708,
                "name":"Nevada",
                "code":"NV",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524365860,
                "country_id":87775772708,
                "name":"New Hampshire",
                "code":"NH",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524398628,
                "country_id":87775772708,
                "name":"New Jersey",
                "code":"NJ",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524431396,
                "country_id":87775772708,
                "name":"New Mexico",
                "code":"NM",
                "tax_name":"GRT",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524464164,
                "country_id":87775772708,
                "name":"New York",
                "code":"NY",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524496932,
                "country_id":87775772708,
                "name":"North Carolina",
                "code":"NC",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524529700,
                "country_id":87775772708,
                "name":"North Dakota",
                "code":"ND",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524562468,
                "country_id":87775772708,
                "name":"Northern Mariana Islands",
                "code":"MP",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524595236,
                "country_id":87775772708,
                "name":"Ohio",
                "code":"OH",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524628004,
                "country_id":87775772708,
                "name":"Oklahoma",
                "code":"OK",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524660772,
                "country_id":87775772708,
                "name":"Oregon",
                "code":"OR",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524693540,
                "country_id":87775772708,
                "name":"Palau",
                "code":"PW",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524726308,
                "country_id":87775772708,
                "name":"Pennsylvania",
                "code":"PA",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524759076,
                "country_id":87775772708,
                "name":"Puerto Rico",
                "code":"PR",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524791844,
                "country_id":87775772708,
                "name":"Rhode Island",
                "code":"RI",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524824612,
                "country_id":87775772708,
                "name":"South Carolina",
                "code":"SC",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524857380,
                "country_id":87775772708,
                "name":"South Dakota",
                "code":"SD",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524890148,
                "country_id":87775772708,
                "name":"Tennessee",
                "code":"TN",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524922916,
                "country_id":87775772708,
                "name":"Texas",
                "code":"TX",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524955684,
                "country_id":87775772708,
                "name":"Utah",
                "code":"UT",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904524988452,
                "country_id":87775772708,
                "name":"Vermont",
                "code":"VT",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904525185060,
                "country_id":87775772708,
                "name":"Virgin Islands",
                "code":"VI",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904525021220,
                "country_id":87775772708,
                "name":"Virginia",
                "code":"VA",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904525053988,
                "country_id":87775772708,
                "name":"Washington",
                "code":"WA",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904525086756,
                "country_id":87775772708,
                "name":"West Virginia",
                "code":"WV",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904525119524,
                "country_id":87775772708,
                "name":"Wisconsin",
                "code":"WI",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             },
             {
                "id":904525152292,
                "country_id":87775772708,
                "name":"Wyoming",
                "code":"WY",
                "tax_name":"State Tax",
                "tax_type":null,
                "shipping_zone_id":46432583716,
                "tax":0,
                "tax_percentage":0
             }
          ]
       }
    ]
 };